exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato:400,400i,700&display=swap);", ""]);

// module
exports.push([module.id, "body {\n  font-family: 'Lato', sans-serif;\n  text-align: left;\n}\n\n.main {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  width: 80%;\n  margin: 0 auto;\n\n}\n\n.content {\n  flex: 1 1;\n}\n\nh1 {\n  color: #eb8628;\n}\n\na {\n  color: #eb8628;\n}\n\nstrong {\n  font-weight: 800;\n}\n\ntable {\n  margin-left: auto;\n  margin-right: auto;\n}\n\nth, td {\n  margin-left: 1px;\n  padding: 10px;\n}\n\nul {\n  margin: 0 0 3px 0;\n  padding: 0 0 3px 0;\n  display: inline-block;\n}", ""]);

// exports
